import * as THREE from 'three';
import Panel from '@scene/objects/panel';
import SafetyBarrierObject from '@scene/generators/safety-barrier/safety-barrier.object';
import { initState } from '../dimension';
import { APP_TYPES } from '@config';
import { ScrewGroup } from '@scene/objects/screw';
import Axis from '@scene/axis';
import { SafetyBarrierPerspective } from '@reducers/camera/defaults/safetyBarrier';


const basePlateSet = [{
  id: 'icon_safetybarrier-baseplate-01',
  icon: 'icon_safetybarrier-baseplate-01',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: null,
    },
    screw: {
      count: {
        n: 1,
        m: 1,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.FILLED_SQUARE,
      padding: {
        s1: 100,
        s2: 100,
        dy: 75,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-02',
  icon: 'icon_safetybarrier-baseplate-02',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: null
    },
    screw: {
      count: {
        n: 2,
        m: 1,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.FILLED_SQUARE,
      padding: {
        s1: 100,
        s2: 100,
        dy: 75,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-02-vertical',
  icon: 'icon_safetybarrier-baseplate-02-vertical',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: null,
    },
    screw: {
      count: {
        n: 1,
        m: 2,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.FILLED_SQUARE,
      padding: {
        s1: 100,
        s2: 70,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-02-diagonal',
  icon: 'icon_safetybarrier-baseplate-02-diagonal',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: null
    },
    screw: {
      count: {
        n: 2,
        m: 2,
        ignorePositions: [{ n: 1, m: 1 }, { n: 2, m: 2 }],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.FILLED_SQUARE,
      padding: {
        s1: 100,
        s2: 70,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-03',
  icon: 'icon_safetybarrier-baseplate-03',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: null
    },
    screw: {
      count: {
        n: 2,
        m: 2,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.FILLED_SQUARE,
      padding: {
        s1: 100,
        s2: 70,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-04',
  icon: 'icon_safetybarrier-baseplate-04',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: null
    },
    screw: {
      count: {
        n: 3
      },
      formation: ScrewGroup.formation.TRIANGLE,
      padding: {
        s1: 100,
        s2: 70,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-05',
  icon: 'icon_safetybarrier-baseplate-05',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.CIRCLE,
      margin: null
    },
    screw: {
      count: {
        n: 2,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.CIRCLE,
      padding: {
        s1: 100,
        s2: 100,
        dy: 75,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-06',
  icon: 'icon_safetybarrier-baseplate-06',
  tooltip:"TT112",//APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.CIRCLE,
      margin: null
    },
    screw: {
      count: {
        n: 3,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.CIRCLE,
      padding: {
        s1: 100,
        s2: 100,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-07',
  icon: 'icon_safetybarrier-baseplate-07',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.CIRCLE,
      margin: null
    },
    screw: {
      count: {
        n: 4,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.CIRCLE,
      padding: {
        s1: 100,
        s2: 100,
        dy: 50,
        diameter: 100
      }
    }
  }
}];

const bendLikePanelMarginTop = 5;
const bendPlateSet = [{
  id: 'icon_safetybarrier-baseplate-02-diagonal',
  icon: 'icon_safetybarrier-baseplate-02-diagonal',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: {
        top: bendLikePanelMarginTop
      }
    },
    screw: {
      count: {
        n: 2,
        m: 2,
        ignorePositions: [{ n: 1, m: 1 }, { n: 2, m: 2 }],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.FILLED_SQUARE,
      padding: {
        s1: 100,
        s2: 70,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-04',
  icon: 'icon_safetybarrier-baseplate-04',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.SQUARE,
      margin: {
        top: bendLikePanelMarginTop
      }
    },
    screw: {
      count: {
        n: 3
      },
      formation: ScrewGroup.formation.TRIANGLE,
      padding: {
        s1: 100,
        s2: 70,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-06',
  icon: 'icon_safetybarrier-baseplate-06',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.CIRCLE,
      margin: {
        top: bendLikePanelMarginTop
      }
    },
    screw: {
      count: {
        n: 3,
        ignorePositions: [],
        toHorizontalMiddle: []
      },
      formation: ScrewGroup.formation.CIRCLE,
      padding: {
        s1: 100,
        s2: 100,
        dy: 50,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-08',
  icon: 'icon_safetybarrier-baseplate-08',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.BEND,
      margin: null
    },
    screw: {
      forBend: {
        topCount: 2,
        sideCount: 1
      },
      formation: ScrewGroup.formation.BEND,
      padding: {
        s1: 100,
        s2: 100,
        dy: 75,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-09',
  icon: 'icon_safetybarrier-baseplate-09',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.BEND,
      margin: null
    },
    screw: {
      forBend: {
        topCount: 1,
        sideCount: 2
      },
      formation: ScrewGroup.formation.BEND,
      padding: {
        s1: 100,
        s2: 100,
        dy: 75,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-10',
  icon: 'icon_safetybarrier-baseplate-10',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.BEND,
      margin: null
    },
    screw: {
      forBend: {
        topCount: 1,
        sideCount: 1
      },
      formation: ScrewGroup.formation.BEND,
      padding: {
        s1: 100,
        s2: 100,
        dy: 75,
        diameter: 100
      }
    }
  }
}, {
  id: 'icon_safetybarrier-baseplate-11',
  icon: 'icon_safetybarrier-baseplate-11',
  tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
  config: {
    panel: {
      type: Panel.types.BEND,
      margin: null
    },
    screw: {
      forBend: {
        topCount: 2,
        sideCount: 2
      },
      formation: ScrewGroup.formation.BEND,
      padding: {
        s1: 100,
        s2: 100,
        dy: 75,
        diameter: 100
      }
    }
  }
}];

export const buttonsOptions = [{
  id: 'edge_slab',
  title:"S170", //'Edge slab',
  icon: 'icon_safetybarrier-type-1',
  tooltip: "TT113",//APP_TOOLTIPS.TOOLTIP_EDGE_SLAB.Content,
  subtypes: [{
    id: 'edge_slab_type-1',
    icon: 'icon_safetybarrier-type-1',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-02',
    plate: basePlateSet,
    config: {
      panel: {
        dpp: {
          active: true
        },
        lyh: {
          active: false
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.VERTICAL_X
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Edge_slab.basePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Edge_slab.perspectiveCamera
    }
  }, {
    id: 'edge_slab_type-2',
    icon: 'icon_safetybarrier-type-1-pos-2',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-11',
    plate: bendPlateSet,
    config: {
      panel: {
        dpp: {
          active: false
        },
        lyh: {
          active: true
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.VERTICAL_X
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Edge_slab.basePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Edge_slab.perspectiveCamera
    }
  }],
  config: {
    type: SafetyBarrierObject.types.EDGE_SLAB,
    ground: {
      padding: {
        C1x: null,
        C1y: null
      }
    },
    camera2D: {
      position: new THREE.Vector3(10, 0, 0)
    }
  }
}, {
  id: 'floor_slab',
  title:"S171",//'Floor slab',
  icon: 'icon_safetybarrier-type-2',
  tooltip:"TT115", //APP_TOOLTIPS.TOOLTIP_FLOOR_SLAB.Content,
  subtypes: [{
    id: 'floor_slab_type-2',
    icon: 'icon_safetybarrier-type-2',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-02',
    plate: basePlateSet,
    config: {
      panel: {
        dpp: {
          active: false
        },
        lyh: {
          active: false
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.HORIZONTAL_Y
      },
      orientation: {
        orientation3D: Axis.types.Z_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Floor_slab.basePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Floor_slab.perspectiveCamera
    }
  }],
  config: {
    type: SafetyBarrierObject.types.FLOOR_SLAB,
    ground: {
      padding: {
        C1x: null,
        C1y: 100
      }
    },
    camera2D: {
      position: new THREE.Vector3(0.001, 1345.362, 0)
    }
  }
}, {
  id: 'pedestal',
  title: "S172", //'Pedestal',
  icon: 'icon_safetybarrier-type-3',
  tooltip:"TT116", //APP_TOOLTIPS.TOOLTIP_PEDESTAL.Content,
  config: {
    type: SafetyBarrierObject.types.PEDESTAL,
    ground: {
      padding: {
        C1x: null,
        C1y: null
      }
    }
  },
  subtypes: [{
    id: 'pedestal_type-1',
    icon: 'icon_safetybarrier-type-3',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-02',
    config: {
      panel: {
        dpp: {
          active: true
        },
        lyh: {
          active: false
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.HORIZONTAL_Y
      },
      camera2D: {
        position: new THREE.Vector3(0.001, 1345.362, 0)
      },
      orientation: {
        orientation3D: Axis.types.Z_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Pedestal.basePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Pedestal.perspectiveCamera
    },
    plate: basePlateSet
  }, {
    id: 'pedestal_type-2',
    icon: 'icon_safetybarrier-type-3-pos-2',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-02',
    config: {
      panel: {
        dpp: {
          active: true
        },
        lyh: {
          active: false
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.VERTICAL_X
      },
      camera2D: {
        position: new THREE.Vector3(10, 0, 0)
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Pedestal.externalBasePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Pedestal.perspectiveCamera
    },
    plate: basePlateSet
  }, {
    id: 'pedestal_type-3',
    icon: 'icon_safetybarrier-type-3-pos-3',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-02',
    config: {
      panel: {
        dpp: {
          active: true
        },
        lyh: {
          active: false
        },
        dpl: {
          active: false
        },
        position: Panel.positions.VERTICAL_X_INVERT
      },
      camera2D: {
        position: new THREE.Vector3(-1168, 23, 0)
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP_Z_FORWARD,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Pedestal.internalBasePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Pedestal.internalPerspectiveCamera
    },
    plate: basePlateSet
  }, {
    id: 'pedestal_type-4',
    icon: 'icon_safetybarrier-type-3-pos-4',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-11',
    config: {
      panel: {
        dpp: {
          active: false
        },
        lyh: {
          active: true
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.VERTICAL_X
      },
      camera2D: {
        position: new THREE.Vector3(0.001, 1345.362, 0)
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Pedestal.externalBasePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Pedestal.perspectiveCamera
    },
    plate: bendPlateSet
  }, {
    id: 'pedestal_type-5',
    icon: 'icon_safetybarrier-type-3-pos-5',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-11',
    config: {
      panel: {
        dpp: {
          active: false
        },
        lyh: {
          active: true
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.VERTICAL_X_INVERT
      },
      camera2D: {
        position: new THREE.Vector3(-1168, 23, 0)
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP_Z_FORWARD,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Pedestal.internalBasePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Pedestal.internalPerspectiveCamera
    },
    plate: bendPlateSet
  }]
}, {
  id: 'stairs',
  title:"S173", //'Stairs',
  icon: 'icon_safetybarrier-type-4',
  tooltip:"TT117", //APP_TOOLTIPS.TOOLTIP_STAIRS.Content,
  config: {
    type: SafetyBarrierObject.types.STAIRS,
    ground: {
      padding: {
        C1x: 80,
        C1y: 80
      }
    }
  },
  subtypes: [{
    id: 'stairs_type-1',
    icon: 'icon_safetybarrier-type-4-pos-1',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-02',
    plate: basePlateSet,
    config: {
      panel: {
        dpp: {
          active: false
        },
        lyh: {
          active: false
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.HORIZONTAL_X
      },
      camera2D: {
        position: new THREE.Vector3(0.001, 1345.362, 0)
      },
      orientation: {
        orientation3D: Axis.types.Z_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Stairs.topBasePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Stairs.perspectiveCamera
    }
  }, {
    id: 'stairs_type-2',
    icon: 'icon_safetybarrier-type-4',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-02',
    plate: basePlateSet,
    config: {
      panel: {
        dpp: {
          active: true
        },
        lyh: {
          active: false
        },
        dpl: {
          active: true
        },
        disableEdgeDistance: true,
        position: Panel.positions.VERTICAL_X
      },
      camera2D: {
        position: new THREE.Vector3(10, 0, 0)
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Stairs.basePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Stairs.perspectiveCamera
    }
  }, {
    id: 'stairs_type-3',
    icon: 'icon_safetybarrier-type-4-pos-3',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    defaultPlateId: 'icon_safetybarrier-baseplate-11',
    plate: bendPlateSet,
    config: {
      panel: {
        dpp: {
          active: false
        },
        lyh: {
          active: true
        },
        dpl: {
          active: true
        },
        disableEdgeDistance: true,
        position: Panel.positions.VERTICAL_X
      },
      camera2D: {
        position: new THREE.Vector3(10, 0, 0)
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Stairs.basePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Stairs.perspectiveCamera
    }
  }]
}, {
  id: 'between_walls',
  title: "S879",//'Between walls',
  tooltip:"TT118", //APP_TOOLTIPS.TOOLTIP_BETWEEN_WALLS.Content,
  icon: 'icon_safetybarrier-type-5',
  subtypes: [{
    id: 'between_walls_type-1',
    icon: 'icon_safetybarrier-type-2',
    tooltip:"TT104", //APP_TOOLTIPS.TOOLTIP_SUBTYPES.Content,
    config: {
      panel: {
        dpp: {
          active: false
        },
        lyh: {
          active: false
        },
        dpl: {
          active: false
        },
        disableEdgeDistance: false,
        position: Panel.positions.VERTICAL_X
      },
      orientation: {
        orientation3D: Axis.types.Y_TOP_Z_LEFT,
        orientation2D: Axis.types.Y_TOP_2D
      },
      basePlateCamera: SafetyBarrierPerspective.Between_Walls.basePlateCamera,
      perspectiveCamera: SafetyBarrierPerspective.Between_Walls.perspectiveCamera
    },
    defaultPlateId: 'icon_safetybarrier-baseplate-01',
    plate: [{
      id: 'icon_safetybarrier-baseplate-01',
      icon: 'icon_safetybarrier-baseplate-01',
      tooltip:"TT112",//APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
      config: {
        panel: {
          type: Panel.types.SQUARE,
          margin: null
        },
        screw: {
          count: {
            n: 1,
            m: 1,
            ignorePositions: [],
            toHorizontalMiddle: []
          },
          formation: ScrewGroup.formation.FILLED_SQUARE,
          padding: {
            s1: 100,
            s2: 100,
            dy: 75,
            diameter: 100
          }
        }
      }
    }, {
      id: 'icon_safetybarrier-baseplate-02-vertical',
      icon: 'icon_safetybarrier-baseplate-02-vertical',
      tooltip:"TT112", //APP_TOOLTIPS.TOOLTIP_SAFETY_BARRIER_ANCHOR.Content,
      config: {
        panel: {
          type: Panel.types.SQUARE,
          margin: null
        },
        screw: {
          count: {
            n: 1,
            m: 2,
            ignorePositions: [],
            toHorizontalMiddle: []
          },
          formation: ScrewGroup.formation.FILLED_SQUARE,
          padding: {
            s1: 100,
            s2: 70,
            dy: 50,
            diameter: 100
          }
        }
      }
    }]
  }],
  config: {
    type: SafetyBarrierObject.types.BETWEEN_WALLS,
    ground: {
      padding: {
        C1x: initState[APP_TYPES.SAFETY_BARRIER].wallDimensions.w / 2,
        C2x: initState[APP_TYPES.SAFETY_BARRIER].wallDimensions.w / 2 
      }
    },
    camera2D: {
      position: new THREE.Vector3(12, 39, -1344)
    }
  }
}];



// WEBPACK FOOTER //
// ./src/reducers/selectors/application/initialState-safety-barrier.js